"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterLogisticOffersByLogisticRoute = void 0;
exports.hasLogistiOffersForDeliveryType = hasLogistiOffersForDeliveryType;
exports.isLogisticRoutePossible = isLogisticRoutePossible;
const convert_logistic_route_to_delivery_type_1 = require("../convert-logistic-route-to-delivery-type");
function hasLogistiOffersForDeliveryType(logisticOffers, deliveryType) {
    return logisticOffers.filter((0, exports.filterLogisticOffersByLogisticRoute)(deliveryType)).length > 0;
}
/**
 *
 * @deprecated use hasLogistiOffersForDeliveryType instead
 *
 */
function isLogisticRoutePossible(logisticOffers, deliveryType) {
    return hasLogistiOffersForDeliveryType(logisticOffers, deliveryType);
}
const filterLogisticOffersByLogisticRoute = (logisticRoute) => (logisticOffer) => (0, convert_logistic_route_to_delivery_type_1.convertLogisticRouteToDeliveryType)(logisticOffer.logisticRoute) === logisticRoute;
exports.filterLogisticOffersByLogisticRoute = filterLogisticOffersByLogisticRoute;
